module.exports = __webpack_public_path__ + "static/media/Kereskedesek-bg.a76a582f.jpg";